
<template>
  <div id="div"></div>
</template>

<script>
import E from "wangeditor";
export default {
  name: "editor",
  props: {
    getTrigger: {
      default() {
        return 0;
      },
    },
    content: {
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    getTrigger() {
      this.getContent();
    },
  },
  mounted() {
    this.editor = new E("#div");
    // 配置菜单栏，删减菜单，调整顺序
    this.editor.config.menus = [
      "head",
      "bold",
      "fontSize",
      "fontName",
      "italic",
      "underline",
      "strikeThrough",
      "indent",
      "lineHeight",
      "foreColor",
      "backColor",
      "list",
      "justify",
      "table",
      "splitLine",
      "undo",
      "redo",
    ];
    this.editor.config.onchange = (newHtml) => {
      this.$emit("update:content", newHtml);
    };
    this.editor.create();

  },
  methods: {
    setHtml(html) {
      this.editor.txt.html(html);
    },
    clear() {
      this.editor.txt.clear();
    },
  },
};
</script>
